const profileSourceCache = {
  ALL: 'All',
  BRIDG_IDENTIFIED: 'Bridg Identified',
  KNOWN: 'Brand Identified',
};

/**
 * Accepts a lower-cased, upper-cased, and snake-cased entry to return a upper-cased, formatted result.
 * @function upperCaseAndFormatProfileSource
 * @param {String}
 * @return {String}
 */
export default profileSource => profileSourceCache[profileSource] || 'Unknown';
